import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: {},
    token: '',
    API_ROOT: '',
    proData: {},// 当前项目和环境
    ifCompose: false,// 量表当前编辑状态
    cTemplate: {}// 当前选中量表信息

  },
  mutations: {
    updateUser(state, data) {
      state.user = data;
    },
    updateToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    updateAPIROOT(state, data) {
      state.API_ROOT = data;
    },
    updateProData(state, data) {
      state.proData = data;
    },
    updateIfCompose(state, ifCompose) {
      state.ifCompose = ifCompose;
    },
    updateCTemplate(state, data) {
      state.cTemplate = data;
    },
  },
});

export default store;
